import Backbone from 'backbone'
import _ from 'lodash'
import template from './database-configuration.hbs'
import formHelper from 'scoreboard/components/form-helper'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import hostValidator from 'scoreboard/components/validators/host-validator'
import positiveIntegerValidator from 'scoreboard/components/validators/positive-integer-validator'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import databaseNameValidator from 'scoreboard/components/validators/database-name-validator'
import constants from 'scoreboard/components/constants'
import Database from './database'

var DatabaseConfiguration = Backbone.View.extend({

	className: 'database-configuration',

	events: {
		'change .config-type-checkbox': 'configType'
	},

	/**
	 * Controls common to scoreboard databases and database import connections
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Database|Connection} options.model a model containing information
	 * about the database conection
	 * @param {String} options.product database product this configuration is for.
	 * the model may not always have this set yet
	 */
	initialize(options = {}) {
		this.options = options
		this._markedFields = []

		// set defaults if necessary
		if (!this.model.get('port')) {
			this.model.set('port', Database.getDefaultPort(this.model.get('product')))
		}
		if (!this.model.get('host')) {
			this.model.set('host', 'localhost')
		}
	},

	render() {
		this.$el.empty().append(template(_.extend({}, this.model.attributes, this.context())))
		formHelper.writeToDom(this.model, this.el)

		if (!this.model.isNew() && _.isEmpty(this.$('[name=password]').val())) {
			this.$('[name=password]').val(constants.PASSWORD_PLACEHOLDER_KEY)
		}

		this._markedFields.push(new MarkedField({
			el: this.$('[name=host]'),
			validator: [requiredValidator, hostValidator]
		}).render())
		this._markedFields.push(new MarkedField({
			el: this.$('[name=port]'),
			validator: [requiredValidator, positiveIntegerValidator],
			evaluator: numericEvaluator
		}).render())
		this._markedFields.push(new MarkedField({
			el: this.$('[name=databaseName]'),
			validator: [requiredValidator, databaseNameValidator]
		}).render())
		this._markedFields.push(new MarkedField({
			el: this.$('[name=username]'),
			validator: requiredValidator
		}).render())
		this._markedFields.push(new MarkedField({
			el: this.$('[name=password]'),
			validator: requiredValidator
		}).render())

		this._markedFields.push(new MarkedField({
			el: this.$('textarea'),
			validator: requiredValidator
		}).render())

		// buy default everything is standard, so if the model is non-standard
		// then go ahead and toggle the fields
		if (!this.model.get('standard')) {
			this.configType()
		}

		return this
	},

	context: function() {
		// In Hana, the database has one or more schemas
		const databaseNamePrefix = this.options.product === 'hana' ? 'schemaName' : 'databaseName'
		return {
			databaseNameLabel: `admin.databaseConnections.all.${databaseNamePrefix}`
		}
	},

	configType: function(e) {
		this.$('.standard-configuration, .non-standard-configuration').toggleClass('is-not-displayed')

		// needed because some controls may have started as hidden and couldn't have picked
		// up correct sizes
		_.invokeMap(this._markedFields, 'padInputField')

		// don't trigger validation of marked-fields
		e && e.stopPropagation()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this._markedFields, 'remove')
	}

})

export default DatabaseConfiguration

DatabaseConfiguration.__filename__ = 'admin/connections/database-configuration.js'
